import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { DocumentSectionRow } from "../models/DocumentSection";

export const drawPdfKeyValueList = (document: jsPDF, rows: DocumentSectionRow[], startY: number) => {
  autoTable(document, {
    startY,
    body: rows.map((row) => [row.label, row.value]),
    theme: "plain",
    styles: { fontSize: 9, cellPadding: 1.5, textColor: [51, 65, 85] },
    columnStyles: { 0: { fontStyle: "bold", cellWidth: 34 } },
    margin: { left: 14, right: 14 },
  });
  return (document as jsPDF & { lastAutoTable: { finalY: number } }).lastAutoTable.finalY + 4;
};
